import { render, staticRenderFns } from "./AdvButton.vue?vue&type=template&id=33a2f824&scoped=true"
import script from "./AdvButton.vue?vue&type=script&lang=js"
export * from "./AdvButton.vue?vue&type=script&lang=js"
import style0 from "./AdvButton.vue?vue&type=style&index=0&id=33a2f824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2f824",
  null
  
)

export default component.exports